import { ELeadSource, ELeadSourceDetail } from '../services/responses/lead.response';

/// Chave de tradução de cada origem, usada por duas telas (duas cópias divergiriam).
export const SOURCE_KEY: Record<ELeadSource, string> = {
    [ELeadSource.Manual]: 'crmMultichannel.origemManual',
    [ELeadSource.WhatsApp]: 'crmMultichannel.origemWhatsApp',
    [ELeadSource.AdClick]: 'crmMultichannel.origemAnuncio',
    [ELeadSource.Website]: 'crmMultichannel.origemSite',
    [ELeadSource.Instagram]: 'crmMultichannel.origemInstagram',
    [ELeadSource.Email]: 'crmMultichannel.origemEmail',
    [ELeadSource.TikTok]: 'crmMultichannel.origemTikTok',
    [ELeadSource.Telegram]: 'crmMultichannel.origemTelegram',
    [ELeadSource.Sms]: 'crmMultichannel.origemSms',
    [ELeadSource.Import]: 'crmMultichannel.origemImportacao',
    [ELeadSource.RdStation]: 'crmMultichannel.origemRdStation',
};

/// Na ordem do enum, para a lista de escolha desenhar sempre igual.
export const SOURCES = (Object.keys(SOURCE_KEY) as unknown as ELeadSource[])
    .map(Number)
    .sort((a, b) => a - b)
    .map((value) => ({ value, key: SOURCE_KEY[value as ELeadSource] }));

/// Pessoa usa os mesmos números: um mapa só para lead e pessoa.
export const SOURCE_DETAIL_KEY: Record<ELeadSourceDetail, string> = {
    [ELeadSourceDetail.MetaLeadForm]: 'crmMultichannel.origemFormularioMeta',
    [ELeadSourceDetail.FacebookLeadForm]: 'crmMultichannel.origemFormularioFacebook',
    [ELeadSourceDetail.InstagramLeadForm]: 'crmMultichannel.origemFormularioInstagram',
    [ELeadSourceDetail.InstagramAdMessage]: 'crmMultichannel.origemDirectInstagram',
    [ELeadSourceDetail.WhatsAppAdMessage]: 'crmMultichannel.origemWhatsAppAnuncio',
    [ELeadSourceDetail.MessengerAdMessage]: 'crmMultichannel.origemMessengerAnuncio',
};

/// "Anúncio · Formulário do Facebook"; sem detalhe, só a origem.
export const sourceLabel = (t: (key: string) => string, source: ELeadSource, detail?: ELeadSourceDetail | null): string =>
    [t(SOURCE_KEY[source] ?? ''), detail ? t(SOURCE_DETAIL_KEY[detail]) : null].filter(Boolean).join(' · ');
